<template>
  <div class="h-full flex justify-center items-center">
    <div
      class="flex h-8 w-full items-center justify-center rounded-2xl border border-input px-3 py-2 text-sm whitespace-nowrap"
      :class="{
        '!bg-[#D1F1BB]': isSale,
        '!bg-[#FFE072]': !isSale,
      }"
    >
      {{ isSale ? t('sale') : t('quoted') }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'QuoteStatusBadge',

  props: {
    saleOrderID: {
      type: String,
      default: null
    }
  },

  setup(props) {
    const { t } = useI18n({
      messages: {
        en: {
          quoted: 'Quoted',
          sale: 'Sale'
        },
        ar: {
          quoted: 'عرض',
          sale: 'تم البيع'
        }
      }
    })

    const isSale = ref(!!props.saleOrderID)

    return { t, isSale }
  },

  // ag-grid cell renderer support
  mounted() {
    const data = (this as any).params?.data
    if (data) {
      this.isSale = !!data.saleOrderID
    }
  }
})
</script>
